<template>
  <v-card>
    <v-card-title>Data Mata Pelajaran</v-card-title>
    <v-card-text>
      <div align="right">
        <v-btn
          dark
          color="green"
          @click="
            req = {};
            modal.import = true;
          "
          v-if="$root.app.isAdmin"
          class="mr-2"
        >
          <v-icon>mdi-file</v-icon>
          Import Excel
        </v-btn>
        <v-btn
          dark
          color="blue"
          @click="
            req = {};
            modal.create = true;
          "
          v-if="$root.app.isAdmin"
        >
          <v-icon>mdi-plus</v-icon>
          Tambah
        </v-btn>
      </div>
      <form
        @submit.prevent="
          () => {
            options.page = filter.page = 1;
            get();
          }
        "
      >
        <v-text-field
          label="Search"
          v-model="filter.search"
          @change="
            () => {
              options.page = filter.page = 1;
              get();
            }
          "
          append-icon="mdi-magnify"
        ></v-text-field>
      </form>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 50, 100],
        }"
        disable-sort
        :headers="
          $root.app.isAdmin
            ? [
                {
                  text: 'Kode',
                  value: 'kode',
                },
                {
                  text: 'Nama Mapel',
                  value: 'nama',
                },
                {
                  text: 'Opsi',
                  value: 'actions',
                },
              ]
            : [
                {
                  text: 'Kode',
                  value: 'kode',
                },
                {
                  text: 'Nama Mapel',
                  value: 'nama',
                },
              ]
        "
        :items="datas"
        :loading="is.loading"
        loading-text="Loading... Please wait"
        :server-items-length="recordsTotal"
        :options.sync="options"
      >
        <template slot="item.actions" slot-scope="{ item }">
          <v-btn
            icon
            color="blue"
            @click="
              req = item;
              modal.edit = true;
            "
          >
            <v-icon>mdi-pen</v-icon>
          </v-btn>
          <v-btn
            icon
            color="red"
            @click="
              req = item;
              modal.delete = true;
            "
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <v-dialog v-model="modal.create">
      <v-form ref="create" @submit.prevent="store">
        <v-card width="500">
          <v-card-title>Tambah Mata Pelajaran</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.kode"
              placeholder="Masukkan Kode"
              label="Kode"
              :rules="[(v) => !!v || 'kode harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.nama"
              placeholder="Masukkan Nama"
              label="Nama"
              :rules="[(v) => !!v || 'nama harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.create = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.edit">
      <v-form ref="edit" @submit.prevent="update">
        <v-card width="500">
          <v-card-title>Edit Mata Pelajaran</v-card-title>
          <v-card-text>
            <v-alert
              dense
              v-show="is.submit"
              text
              icon="mdi-clock-fast"
              border="left"
              color="blue"
              >Menunggu...</v-alert
            >
            <v-text-field
              v-model="req.kode"
              placeholder="Masukkan Kode"
              label="Kode"
              :rules="[(v) => !!v || 'kode harus diisi']"
            ></v-text-field>
            <v-text-field
              v-model="req.nama"
              placeholder="Masukkan Nama"
              label="Nama"
              :rules="[(v) => !!v || 'nama harus diisi']"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Simpan</v-btn>
            <v-btn type="button" text color="red" @click="modal.edit = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="modal.delete">
      <v-card width="450">
        <v-form @submit.prevent="destroy">
          <v-card-title>Hapus Mata Pelajaran</v-card-title>
          <v-card-text>Anda yakin menghapus {{ req.nama }}?</v-card-text>
          <v-card-actions>
            <v-btn type="submit" text color="blue">Hapus</v-btn>
            <v-btn type="button" text color="red" @click="modal.delete = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modal.import">
      <v-card width="500">
        <v-form @submit.prevent="importAction">
          <v-card-title>Import Mata Pelajaran</v-card-title>
          <v-card-text>
            <p>
              Unduh contoh format import
              <a :href="contohImport" target="_blank">disini</a>
            </p>
            <v-file-input
              @change="handleImport"
              label="File"
              hint="Pilih File"
              persistent-hint
              show-size
              accept="application/*"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-btn type="submit" color="blue" text>Simpan</v-btn>
            <v-btn type="button" color="red" text @click="modal.import = false"
              >Batal</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      datas: [],
      modal: {
        create: false,
        edit: false,
        delete: false,
        import: false,
      },
      req: {},
      is: {
        loading: true,
        submit: false,
      },
      filter: {
        limit: 10,
        search: "",
        page: 1,
      },
      options: {},
      recordsTotal: 0,
      contohImport: "",
      req_import: {},
    };
  },
  created() {
    this.get();
  },
  watch: {
    options(val) {
      this.filter.limit = val.itemsPerPage;
      this.filter.page = val.page;
      this.get();
    },
  },
  methods: {
    get() {
      this.req = {
        jurusan_id: "",
      };
      this.is.loading = true;
      this.$root.app.http.get("/api/matapelajaran", this.filter).then((res) => {
        this.datas = res.data;
        this.contohImport = res.contohImport;
        this.recordsTotal = res.recordsTotal;
        this.is.loading = false;
      });
    },
    store() {
      this.is.submit = true;
      if (this.$refs.create.validate()) {
        this.$root.app.http.post("/api/matapelajaran", this.req).then((res) => {
          this.is.submit = false;
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.create = false;
            this.$root.app.notif(res.message);
          }
        });
      }
    },
    update() {
      this.is.submit = true;
      if (this.$refs.edit.validate()) {
        this.$root.app.http
          .put("/api/matapelajaran/" + this.req.id, this.req)
          .then((res) => {
            this.is.submit = false;
            if (res.error) {
              this.$root.app.notif(res.message[0], true);
            } else {
              this.get();
              this.modal.edit = false;
              this.$root.app.notif(res.message);
            }
          });
      }
    },
    destroy() {
      this.$root.app.http
        .del("/api/matapelajaran/" + this.req.id)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.delete = false;
            this.$root.app.notif(res.message);
          }
        });
    },
    importAction() {
      this.$root.app.http
        .post("/api/matapelajaran/import", this.req_import)
        .then((res) => {
          if (res.error) {
            this.$root.app.notif(res.message[0], true);
          } else {
            this.get();
            this.modal.import = false;
            this.$root.app.notif(res.message);
          }
        });
    },
    handleImport(val) {
      this.$root.app.toBase64(val, (result) => {
        this.req_import.file = result;
      });
    },
  },
};
</script>
